import { useMutation } from '@tanstack/react-query'
import {
  BulkLocationCreateData,
  BulkLocationCheckResponse,
  bulkLocationCheck,
  BulkLocationCreateErrorResponse,
} from 'api/shifts'

export const useBulkLocationCheckMutation = () => {
  return useMutation<
    BulkLocationCheckResponse,
    BulkLocationCreateErrorResponse,
    BulkLocationCreateData
  >({
    mutationFn: bulkLocationCheck,
  })
}
